import React from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { AcronymSection, AcronymList, AcronymItem, AcronymLetter, AcronymText } from './ThankYouStyles';
import { DescriptionSection, DescriptionText, EnergyParticles, EnergyParticle, EnergyCircle, HighlightedWord } from './ThankYouStyles';
import { PhoneButton, ButtonText } from './HeroSectionStyles';
import { FaPhone } from 'react-icons/fa';
import ChannelsComponent from './ChannelsSection';
import ProcessFlowSection from './ProcessFlowSection';
import PlatformVideoSection from './PlatformVideoSection';

// Container estilizado para as seções de informação
const InfoSectionsContainer = styled.div`
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
  margin-top: 4rem;
  padding-top: 2rem;
  
  &.visible {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Container para o botão de telefone no final da página
const BottomPhoneButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 4rem auto 2rem;
  width: 100%;
  text-align: center;
  
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

// Texto do botão centralizado
const AdjustedButtonText = styled(ButtonText)`
  position: relative;
  left: 0; /* Removido o deslocamento para garantir centralização perfeita */
  text-align: center;
  margin: 1rem auto 0;
`;

const InfoSections = ({ isVisible, setRef, onOpenModal }) => {
  // Verificar se estamos na rota /ty
  const location = useLocation();
  const isThankYouPage = location.pathname === '/ty';

  // Dados da sigla BIANCA
  const acronymData = [
    { letter: 'B', text: 'Bot de' },
    { letter: 'I', text: 'Inteligência' },
    { letter: 'A', text: 'Artificial para' },
    { letter: 'N', text: 'Nutrição e' },
    { letter: 'C', text: 'Controle de' },
    { letter: 'A', text: 'Agendamento' }
  ];

  // Gerar partículas de energia aleatórias
  const renderEnergyParticles = () => {
    const particles = [];
    const colors = ['#00FFFF', '#64B6FF', '#0080FF', '#FFFFFF'];
    const sizes = ['4px', '6px', '8px', '10px'];
    
    for (let i = 0; i < 20; i++) {
      const top = `${Math.random() * 100}%`;
      const left = `${Math.random() * 100}%`;
      const color = colors[Math.floor(Math.random() * colors.length)];
      const size = sizes[Math.floor(Math.random() * sizes.length)];
      const duration = `${2 + Math.random() * 3}s`;
      const delay = `${Math.random() * 2}s`;
      
      particles.push(
        <EnergyParticle 
          key={i}
          top={top}
          left={left}
          color={color}
          size={size}
          duration={duration}
          delay={delay}
        />
      );
    }
    
    return particles;
  };

  return (
    <InfoSectionsContainer className={isVisible ? 'visible' : ''} ref={setRef}>
      {/* Seção de explicação da sigla BIANCA */}
      <AcronymSection isVisible={isVisible}>
        <AcronymList>
          {acronymData.map((item, index) => (
            <AcronymItem key={index} index={index} isVisible={isVisible}>
              <AcronymLetter isVisible={isVisible}>{item.letter}</AcronymLetter>
              <AcronymText index={index} isVisible={isVisible}>{item.text}</AcronymText>
            </AcronymItem>
          ))}
        </AcronymList>
      </AcronymSection>
      
      {/* Seção de descrição da BIANCA */}
      <DescriptionSection>
        <EnergyParticles>
          {renderEnergyParticles()}
        </EnergyParticles>
        <EnergyCircle />
        <DescriptionText>
          BIANCA é uma agente de IA especializada em <HighlightedWord>maximizar</HighlightedWord> a conversão de <HighlightedWord>leads</HighlightedWord> em <HighlightedWord>agendamentos</HighlightedWord>
        </DescriptionText>
      </DescriptionSection>
      
      {/* Nova seção de canais de atendimento */}
      <ChannelsComponent />
      
      {/* Nova seção de fluxo de processo */}
      <ProcessFlowSection onOpenModal={onOpenModal} />
      
      {/* Nova seção de vídeo da plataforma */}
      <PlatformVideoSection />
    </InfoSectionsContainer>
  );
};

export default InfoSections;
